module.exports = __webpack_public_path__ + "static/media/reddit_logo.8e1271cb.svg";